export default "__VITE_ASSET__f2ffb6d0__"